import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Award, CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-103">
      {/* Background with warm gradients to simulate wood/sunset */}
      <div className="absolute inset-0 z-0" data-id="element-104">
        <div className="absolute inset-0 bg-gradient-to-br from-sunrise-brown-dark via-sunrise-brown to-sunrise-orange-dark opacity-90" data-id="element-105" />
        <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/e62r12vsc4BohcbyS6D6Dg/Wood-wall-sun.jpg')] bg-cover bg-center mix-blend-overlay opacity-40" data-id="element-106" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-107" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16 text-center md:text-left w-full" data-id="element-108">
        <div className="md:max-w-3xl" data-id="element-109">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-110">
            <h1 className="font-heading font-bold text-5xl md:text-6xl lg:text-7xl text-white leading-tight mb-6" data-id="element-111">
              Custom Finish Carpentry for{' '}
              <span className="text-sunrise-gold" data-id="element-112">Arizona's</span> Finest Homes
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-lg md:text-xl text-white/90 mb-10 font-light max-w-2xl" data-id="element-113">
            From custom wood ceilings to detailed trim work — craftsmanship you
            can see and feel. Licensed, bonded, and insured.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-12" data-id="element-114">
            <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} className="shadow-lg shadow-sunrise-orange/20" data-id="element-115">
              Get a Free Estimate
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('portfolio')?.scrollIntoView({
            behavior: 'smooth'
          })} className="border-white text-white hover:bg-white hover:text-sunrise-brown" data-id="element-116">
              View Our Work
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.6
        }} className="flex flex-wrap justify-center md:justify-start gap-6 text-white/80 text-sm font-medium tracking-wide" data-id="element-117">
            <div className="flex items-center" data-id="element-118">
              <ShieldCheck className="w-5 h-5 text-sunrise-gold mr-2" data-id="element-119" />
              <span data-id="element-120">Licensed</span>
            </div>
            <div className="flex items-center" data-id="element-121">
              <Award className="w-5 h-5 text-sunrise-gold mr-2" data-id="element-122" />
              <span data-id="element-123">Bonded</span>
            </div>
            <div className="flex items-center" data-id="element-124">
              <CheckCircle className="w-5 h-5 text-sunrise-gold mr-2" data-id="element-125" />
              <span data-id="element-126">Insured</span>
            </div>
            <div className="flex items-center border-l border-white/20 pl-6 ml-2" data-id="element-127">
              <span className="text-sunrise-gold font-bold" data-id="element-128">ROC #363248</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}